import { MinLength, MaxLength } from "class-validator";
import {validate, validateOrReject, Contains, IsInt, Length, IsEmail, IsFQDN,
        IsDate,Min,Max } from "class-validator"; 
import {ValidateIf, IsNotEmpty,IsNumber,IsString,IsEmpty } from "class-validator"; 


export class Stkmj { 
    @MaxLength(10,{message: 'COMPANY 字串太長'}) 
    @IsString({message: 'COMPANY 不是字串型態'}) 
    COMPANY: string = ""; 
  
    @MaxLength(10) 
    CREATOR: string = ""; 
  
    @MaxLength(10) 
    USR_GROUP: string = ""; 
  
    @MaxLength(8) 
    CREATE_DATE: string =""; 
  
    @MaxLength(10) 
    MODIFIER: string = ""; 
  
    @MaxLength(8) 
    MODI_DATE: string = ""; 
  
    @IsNumber() 
    @Max(999) 
    FLAG: number =0; 


    @IsNotEmpty({message: '帳號代號 (MJ001) 不可空白'}) 
    @MaxLength(6,{message: '帳號代號 (MJ001) 資料太長'})
    MJ001: string = '*';            // 帳號代號 6 [DEF:"*"] STKLE STKPI17 單身 STKMM valid:STKMB

    @IsNotEmpty({message: '條件代號 (MJ002) 不可空白'}) 
    @MaxLength(6,{message: '條件代號 (MJ002) 資料太長'})
    MJ002: string = '';            // 條件代號 6 B開頭.

    @MaxLength(30,{message: '名稱 (MJ003) 資料太長'})
    MJ003: string = '';            // 名稱 30 

    @MaxLength(1,{message: '個股或群組 (MJ004) 資料太長'})
    MJ004: string = '1';            // 個股或群組 1 [DEF:"1"]  1:群組 2:個股 3:不設限

    @MaxLength(40,{message: '群組代號 (MJ005) 資料太長'})
    MJ005: string = '000';            // 群組代號 40 [DEF:"000"]逗號分開

    @MaxLength(10,{message: '多空指標 (MJ006) 資料太長'})
    MJ006: string = '';            // 多空指標 10 

    @MaxLength(2000,{message: '條件說明 (MJ007) 資料太長'})
    MJ007: string = '';            // 條件說明 2000 

    @IsNumber() 
    MJ011: number = 0;            // 排序 8 大紅K棒實體N%以上

    @IsNumber() 
    MJ012: number = 0;            // 保留 8.3 0.03  小紅K棒實體N%以上

    @IsNumber() 
    MJ013: number = 0;            // 保留 8.2 [DEF:0] MJ113   超過五日均量N倍

    @IsNumber() 
    MJ014: number = 0;            // 保留 8.4 漲幅大於3%    漲跌/昨日收盤價  到價上限幅度警示

    @IsNumber() 
    MJ015: number = 0;            // 保留 8.4 跌幅大於3%    到價下限幅度警示

    @IsNumber() 
    MJ016: number = 0;            // 成交量N張以上 8.4 500  old:跌幅

    @IsNumber() 
    MJ017: number = 0;            // 保留 8.3 -0.05    大黑K棒實體N%以上

    @IsNumber() 
    MJ018: number = 0;            // 保留 8.3 -0.03    小黑K棒實體N%以上

    @MaxLength(1,{message: '啟用 (MJ019) 資料太長'})
    MJ019: string = 'Y';            // 啟用 1 [DEF:"Y"]

    @MaxLength(8,{message: '開始時間 (MJ020) 資料太長'})
    MJ020: string = '09:00:00';            // 開始時間 8 [DEF:"09:00:00"]

    @MaxLength(8,{message: '結束時間 (MJ021) 資料太長'})
    MJ021: string = '13:30:00';            // 結束時間 8 [DEF:"13:30:00"]

    @IsNumber() 
    MJ022: number = 5;            // 間格時間(分) 6 [DEF:5]

    @MaxLength(1,{message: '通知方法 (MJ023) 資料太長'})
    MJ023: string = 'T';            // 通知方法 1 [DEF:"T"] L:Line T:TELEGRAM  M:MAIL

    @MaxLength(1,{message: '通知頻率 (MJ024) 資料太長'})
    MJ024: string = '1';            // 通知頻率 1 [DEF:"1"] 1:只一次  2:通知到已讀 STK.LE008='Y' 3:不斷通知

    @MaxLength(8,{message: '上次選股日期 (MJ025) 資料太長'})
    MJ025: string = '';            // 上次選股日期 8 

    @MaxLength(8,{message: '上次選股時間 (MJ026) 資料太長'})
    MJ026: string = '';            // 上次選股時間 8 01:23:45

    @MaxLength(500,{message: '條件程式碼 (MJ027) 資料太長'})
    MJ027: string = '';            // 條件程式碼 500 

    @MaxLength(30,{message: '保留 (MJ028) 資料太長'})
    MJ028: string = '';            // 保留 30 程式碼欄位1

    @MaxLength(30,{message: '函數名1 (MJ029) 資料太長'})
    MJ029: string = '';            // 函數名1 30 

    @MaxLength(255,{message: '參數1(JSON格式) (MJ030) 資料太長'})
    MJ030: string = '';            // 參數1(JSON格式) 255 JSON 格式

    @MaxLength(30,{message: '保留 (MJ031) 資料太長'})
    MJ031: string = '';            // 保留 30 

    @MaxLength(30,{message: '函數名2 (MJ032) 資料太長'})
    MJ032: string = '';            // 函數名2 30 = > >= < <=

    @MaxLength(255,{message: '參數2 (MJ033) 資料太長'})
    MJ033: string = '';            // 參數2 255 JSON 格式

    @MaxLength(30,{message: '保留 (MJ034) 資料太長'})
    MJ034: string = '';            // 保留 30 

    @MaxLength(30,{message: '函數名3 (MJ035) 資料太長'})
    MJ035: string = '';            // 函數名3 30 = > >= < <=

    @MaxLength(255,{message: '參數3 (MJ036) 資料太長'})
    MJ036: string = '';            // 參數3 255 JSON 格式

    @MaxLength(30,{message: '保留 (MJ037) 資料太長'})
    MJ037: string = '';            // 保留 30 

    @MaxLength(30,{message: '函數名4 (MJ038) 資料太長'})
    MJ038: string = '';            // 函數名4 30 = > >= < <=

    @MaxLength(255,{message: '參數4 (MJ039) 資料太長'})
    MJ039: string = '';            // 參數4 255 JSON 格式

    @MaxLength(30,{message: '保留 (MJ040) 資料太長'})
    MJ040: string = '';            // 保留 30 

    @MaxLength(30,{message: '函數名5 (MJ041) 資料太長'})
    MJ041: string = '';            // 函數名5 30 = > >= < <=

    @MaxLength(255,{message: '參數5 (MJ042) 資料太長'})
    MJ042: string = '';            // 參數5 255 JSON 格式

    @IsNumber() 
    MJ043: number = 0;            // 保留 11.3 收盤價大於等於

    @IsNumber() 
    MJ044: number = 0;            // 保留 11.3 1500 收盤價小於等於

    @MaxLength(1,{message: '保留 (MJ111) 資料太長'})
    MJ111: string = 'N';            // 保留 1 [DEF:"N"]  大紅K棒實體N%以上

    @MaxLength(1,{message: '保留 (MJ112) 資料太長'})
    MJ112: string = 'N';            // 保留 1 [DEF:"N"] 小紅K棒實體N%以上

    @MaxLength(1,{message: '保留 (MJ113) 資料太長'})
    MJ113: string = 'N';            // 保留 1 [DEF:"N"]  超過五日均量N倍

    @MaxLength(1,{message: '保留 (MJ114) 資料太長'})
    MJ114: string = 'N';            // 保留 1 [DEF:"N"] 到價上限幅度警示

    @MaxLength(1,{message: '保留 (MJ115) 資料太長'})
    MJ115: string = 'N';            // 保留 1 [DEF:"N"] 到價下限幅度警示

    @MaxLength(1,{message: '跌幅 (MJ116) 資料太長'})
    MJ116: string = 'N';            // 跌幅 1 [DEF:"N"] 同MJ115?

    @MaxLength(1,{message: '大黑K棒實體N%以上 (MJ117) 資料太長'})
    MJ117: string = 'N';            // 大黑K棒實體N%以上 1 [DEF:"N"] KSize <= MJ017

    @MaxLength(1,{message: '小黑K棒實體N%以上 (MJ118) 資料太長'})
    MJ118: string = 'N';            // 小黑K棒實體N%以上 1 [DEF:"N"]

    @MaxLength(1,{message: '三陽開泰且爆量小紅 (MJ119) 資料太長'})
    MJ119: string = 'N';            // 三陽開泰且爆量小紅 1 

    @MaxLength(1,{message: '四海遊龍且爆量小紅 (MJ120) 資料太長'})
    MJ120: string = 'N';            // 四海遊龍且爆量小紅 1 


}
